import { memo } from 'react';
import './Button.scss';

const Button = ({
  id = "prime-btn-id",
  variant = 'primary',
  onClick = () => {},
  size = 'md',
  disabled = false,
  style,
  children,
  ...props
}) => {

  if (variant === "link" || variant === "link-danger") {
    return (
      <span
        id={id}
        onClick={disabled ? undefined : onClick}
        style={style}
        className={`prime-btn-link prime-btn-link--${variant}${disabled ? ' prime-btn-link--disabled' : ''}`}
      >
        {children}
      </span>
    );
  }

  const sizeClass = size !== 'md' ? ` prime-btn--${size}` : '';
  const disabledClass = disabled ? ' prime-btn--disabled' : '';
  const variantClass = disabled ? '' : ` prime-btn--${variant}`;

  return (
    <button
      {...props}
      id={id}
      onClick={disabled ? undefined : onClick}
      style={style}
      disabled={disabled}
      className={`prime-btn${variantClass}${sizeClass}${disabledClass}`}
    >
      {children}
    </button>
  );
};

export default memo(Button);
